'use client';

import { useEffect } from 'react';
import { useRollbar } from '@rollbar/react';

import reportErrorDebounced from '@hub/common/src/reportErrorDebounced';

import ErrorMessage from '@hub/common-components/src/ErrorMessage';
import Navbar from '@/components/Navbar';
import { getLogger } from '@hub/common/src/logger';
import { useCitOriginClient } from '@hub/common-components/src/CitOriginClientProvider';

export default function Error({ error, _reset }: { error: Error; _reset: () => void }) {
  const rollbar = useRollbar();
  const citOrigin = useCitOriginClient();
  const logger = getLogger(citOrigin);

  useEffect(() => {
    logger.error({
      event: 'Error in /[accountId]/folder/[folderId]/error.tsx',
      error,
      citOrigin
    });
    reportErrorDebounced(error, rollbar);
  }, [error, rollbar, citOrigin, logger]);

  return (
    <>
      <Navbar priorPageURL='/' disableSearch={true} />
      <ErrorMessage
        message='Unexpected Error'
        subTitle='Oops! Something went wrong while displaying Folder'
        citOrigin={citOrigin}
      />
    </>
  );
}
